import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedDate, FormattedNumber } from 'react-intl'
import Button from '../Button'
import CheckmarkIcon from '../../icons/checkmarkIcon'
import { getSkuPrice } from '../../lib/utils'

const ParticipantCard = ({ participant, index, toggleItem, items, skus }) => {
  const alreadyAdded = items.map(i => i.membershipId).includes(participant.membership.id)

  const price = getSkuPrice(participant.membership.type, 'renewalSkuId', skus)
  const discount = getSkuPrice(participant.membership.type, 'skuId', skus) - price

  return (
    <div className="w-full md:w-1/2 mt-4">
      <div className={`bg-white shadow-md border-t border-grey-lighter ${index % 2 === 0 ? 'md:mr-2' : 'md:ml-2'}`}>
        <div className="p-3 pb-0">
          <h3 className="text-harbor uppercase mb-1 truncate">
            {participant && `${participant.firstName} ${participant.lastName}`}
          </h3>
          <h4 className="text-grass uppercase whitespace-no-wrap truncate">
            <FormattedMessage id={`passTypes.${participant.membership.type}`} defaultMessage="PassType" />
              ,&nbsp;
            <FormattedMessage id={`passTypes.${participant.membership.ageCategory || 'adult'}`} defaultMessage={participant.membership.ageCategory || 'adult'} />
          </h4>
          <div className="text-xs text-grey-darker text-right">
            <FormattedMessage id="dashboard.memberships.expires" defaultMessage="Expires:" />
              &nbsp;
            <FormattedDate value={participant.membership.dateEnd} year='numeric' month='short' day='numeric' />
          </div>
          <div className="flex">
            <div className="flex flex-col items-end">
              <div className="text-sm text-grey-dark">
                <FormattedMessage id="renewals.price" defaultMessage="Renewal price" />
              </div>
              <div className="flex items-end ml-2">
                <h1 className="mb-0 pb-0 leading-none">
                  <FormattedNumber value={price} />
                </h1>
                <div className="text-xs">&nbsp;DKK</div>
              </div>
              <div className="text-xs font-bold text-grey-dark">
                <FormattedMessage id="renewals.discount" defaultMessage="Save" />
                  &nbsp;
                <FormattedNumber value={discount} />
                  &nbsp;DKK
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end">
          <Button
            onClick={() => toggleItem(participant.membership.type, participant.membership.id)}
            sizeName="sm"
            className="m-4 mt-0 flex items-center justify-center"
            bgCss={alreadyAdded && 'bg-grass'}
          >
            {alreadyAdded
            ? (
              <>
                <CheckmarkIcon textCss="-mt-1" sizeCss="h-4 w-4" />
                &nbsp;
                <FormattedMessage id="renewals.card.action-button-remove" defaultMessage="In cart" />
              </>
            ) : (
              <FormattedMessage id="renewals.card.action-button-add" defaultMessage="Renew now" />
            )
          }
          </Button>
        </div>
      </div>
    </div>
)}

ParticipantCard.propTypes = {
  participant: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  toggleItem: PropTypes.func.isRequired,
  items: PropTypes.shape().isRequired,
  skus: PropTypes.instanceOf(Array).isRequired
}

export default ParticipantCard